// 老师端- 实践班级
import services from '../assets/js/services'

export default {
  state: {
    hsjrClassList: {}
  },
  getters: {
  },
  actions: {
    // 获取班级列表
    gethsjrClass(context, payload) {

      return services.gethsjrClass(payload).then(res => {
        context.commit("gethsjrClassList", res)
        return res;
      })
    },
    // 班级添加
    addhsjrClass(context, payload) {
      return services.addhsjrClass(payload).then(res => {
        return res;
      })
    },
    //  班级编辑、删除
    edithsjrClass(context, payload) {
      return services.edithsjrClass(payload).then(res => {
        return res;
      })
    },
    //  班级详情
    gethsjrClassInfo(context, payload) {
      return services.gethsjrClassInfo(payload).then(res => {
        return res;
      })
    },
    // 获取班级学生列表
    gethsjrStudent(context, payload) {
      return services.gethsjrStudent(payload).then(res => {
        return res;
      })
    },
    //  班级学生删除
    delhsjrStudent(context, payload) {
      return services.delhsjrStudent(payload).then(res => {
        return res;
      })
    },
    //  从学生库选择
    choosehsjrStudent(context, payload) {
      return services.choosehsjrStudent(payload).then(res => {
        return res;
      })
    },
    // 获取班级评阅已提交
    gethsjrClassReview(context, payload) {
      return services.gethsjrClassReview(payload).then(res => {
        return res;
      })
    },
    // 获取班级评阅未提交
    gethsjrClassReviewUndo(context, payload) {
      return services.gethsjrClassReviewUndo(payload).then(res => {
        return res;
      })
    },
    // 获取故事详情
    gethsjrClassReviewInfo(context, payload) {
      return services.gethsjrClassReviewInfo(payload).then(res => {
        return res;
      })
    },
    // 故事评分
    setscoreSubmit(context, payload) {
      return services.setscoreSubmit(payload).then(res => {
        return res;
      })
    },
    // 设置公开隐藏
    setStoryStatus(context, payload) {
      return services.setStoryStatus(payload).then(res => {
        return res;
      })
    },
    getsjrClassReviewExportAttach(context, payload) {
      return services.getsjrClassReviewExportAttach(payload).then(res => {
        return res;
      })
    },


  },
  mutations: {
    gethsjrClassList(state, payload) {
      if (payload.code == "0000" && payload.data.items) {
        state.hsjrClassList = payload.data.items;
      }

    }
  }
}